import React, { useState, useEffect } from 'react';
import { Box, useTheme, useMediaQuery, Typography } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import MapOsmCamera from './MapCameraStreaming';
import VideoWall from './VideoWall';
import LoadingComponent from 'src/app/components/Loading';
import { resetVideoSlice } from 'src/features/videoSlice';

const MapViewCamera = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const location = useLocation();
  const showMenu = React.useMemo(() => {
    const query = new URLSearchParams(location.search);
    return JSON.parse(query.get('show_menu') ?? 'true');
  }, [location.search]);

  const [loading, setLoading] = useState(false);

  const deviceSerial = useSelector(state => state.videoSlice.deviceSerial);
  const listVehicleTracking = useSelector(
    state => state.vehicleSlice.listVehicleTracking
  );

  const listCamera4G = deviceSerial
    ? listVehicleTracking.filter(v => v.device_serial === deviceSerial)
    : listVehicleTracking;

  useEffect(() => {
    let mounted = true;

    if (deviceSerial) {
      setLoading(true);
      setTimeout(() => {
        if (mounted) setLoading(false);
      }, 700);
    }

    return () => {
      mounted = false;
    };
  }, [deviceSerial]);

  useEffect(() => {
    return () => {
      dispatch(resetVideoSlice());
    };
  }, [dispatch]);
  if (isMobile && !deviceSerial) {
    return (
      <Box
        height="calc(100vh - 66px)"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        color="#9aa0a6"
      >
        <Typography variant="h4">📷</Typography>
        <Typography style={{ marginTop: 8 }}>
          Vui lòng chọn thiết bị<br />để xem camera
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      height="calc(100vh - 66px)"
      overflow="hidden"
      display="flex"
    >
      {isMobile ? (
        loading ? (
          <LoadingComponent />
        ) : (
          <Box width="100%">
            <VideoWall deviceSerial={deviceSerial} />
          </Box>
        )
      ) : (
        <>
          {deviceSerial ? (
            loading ? (
              <LoadingComponent />
            ) : (
              <Box className="row" style={{ width: '100%', marginLeft: '12px' }}>
                <Box
                  style={{ padding: 0 }}
                  className={showMenu ? 'col-9' : 'col-12'}
                >
                  <VideoWall deviceSerial={deviceSerial} />
                </Box>

                {showMenu && (
                  <Box
                    className="col-3"
                    style={{ paddingLeft: 0 }}
                  >
                    <MapOsmCamera
                      zoom={13}
                      listCamera4GTracking={listCamera4G}
                      showMenu={showMenu}
                      deviceSerial={deviceSerial}
                    />
                  </Box>
                )}
              </Box>
            )
          ) : (
            <Box width="100%">
              <MapOsmCamera
                zoom={13}
                listCamera4GTracking={listVehicleTracking}
                showMenu={showMenu}
                deviceSerial={deviceSerial}
              />
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default React.memo(MapViewCamera);
